export enum ROUTES {
    HOME = "/",
    EXPERIENCES = "/experiences",
    EDUCATION = "/education",
    PROJECTS = "/projects",
    RESOURCES = "/resources",
    YOUTUBE = "/resources/youtube",
    READINGS = "/resources/readings",
}
